import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogCompleteEmailLogin = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({
      name: 'COMPLETE_SIGN_IN',
      channel: ['firebase', 'amplitude', 'ablylog'],
      analytics: {
        ACCOUNT_TYPE: 'EMAIL',
      },
    });
  }, [logAnalyticsEvent]);
};
